import React from 'react';

const PageError = props => {
    return (
        <h1>Ooops! Page not found!</h1>
    )
}

export default PageError;